import { mmFetchWithResponse } from './mmFetchWithResponse';

class FBMOrdersV2Api {
    // Temporary base url for testing
    constructor() {
        this.baseUrl = 'api/fbm/v2';
    }

    async getOrders(fbmAccountName, facilityID, q = undefined) {
        if (fbmAccountName === undefined || facilityID === undefined || facilityID === null) {
            return { status: true, data: { rows: [], pagination: { page: 0, pageSize: 25, hasNextPage: false } } };
        }
        let url = `${this.baseUrl}/orders?fbmAccount=${fbmAccountName}&facilityID=${facilityID}`;
        if (q) {
            url += `&q=${q}`;
        }
        return mmFetchWithResponse(url, { method: 'GET' });
    }

    async getShipments(fbmOrderNum, fbmAccountName) {
        if (fbmOrderNum === undefined || fbmAccountName === undefined) {
            return { status: false, msg: 'fbmOrderNum or fbmAccountName is undefined' };
        }
        // Encode fbmOrderNum to ensure special characters are correctly handled in the URL
        const encodedFbmOrderNum = encodeURIComponent(fbmOrderNum);
        const url = `${this.baseUrl}/orders/shipments?fbmOrderNum=${encodedFbmOrderNum}&fbmAccount=${fbmAccountName}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    }

    async cancelShipment(shipmentId, fbmAccount, reason) {
        const url = `${this.baseUrl}/orders/shipments/cancel`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ shipmentId, fbmAccount, reason }),
        });
    }

    async changeShipmentCarrierService(shipmentId, fbmAccount, carrierServiceId, facilityID) {
        const url = `${this.baseUrl}/orders/shipments/changeService`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ shipmentId, fbmAccount, carrierServiceId, facilityID }),
        });
    }

    async changeOrderCarrierService(orderId, fbmAccount, carrierServiceId, facilityID) {
        const url = `${this.baseUrl}/orders/changeService`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ orderId, fbmAccount, carrierServiceId, facilityID }),
        });
    }

    async getCarrierServices(carrierContains, fbmAccount) {
        const url = `${this.baseUrl}/carrierServices?carrierContains=${carrierContains}&fbmAccount=${fbmAccount}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    }

    async resetShipmentStatus(shipmentId, fbmAccount) {
        const url = `${this.baseUrl}/orders/shipments/resetStatus`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ shipmentId, fbmAccount }),
        });
    }

    async getExportOrderRows(fbmAccount, facilityID) {
        if (facilityID === undefined || facilityID === null) {
            return { status: false, message: 'Please select a facility to export orders.' };
        }
        const url = `${this.baseUrl}/orders/export?fbmAccount=${fbmAccount}&facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    }

    async resetOrderStatus(orderId, fbmAccount, reason) {
        const url = `${this.baseUrl}/orders/resetStatus`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ orderId, fbmAccount, reason }),
        });
    }

    async cancelOrder(orderId, fbmAccount, reason, allowReIngest) {
        const url = `${this.baseUrl}/orders/cancel`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ orderId, fbmAccount, reason, allowReIngest }),
        });
    }

    async bulkCancelOrders(orderIds, fbmAccount, reason) {
        const url = `${this.baseUrl}/orders/bulkCancel`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ orderIds, fbmAccount, reason }),
        });
    }

    async bulkResetOrderStatus(orderIds, fbmAccount, reason) {
        const url = `${this.baseUrl}/orders/bulkResetStatus`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ orderIds, fbmAccount, reason }),
        });
    }

    async getLineHauls(fbmAccount, facilityID, carrier) {
        if (fbmAccount === undefined || facilityID === undefined || carrier === undefined) {
            return { status: false, msg: 'fbmAccount or facilityID or carrier is undefined' };
        }

        const url = `${this.baseUrl}/lineHauls?fbmAccount=${fbmAccount}&facilityID=${facilityID}&carrier=${carrier}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    }

    async changeLineHaul(shipmentId, fbmAccount, lineHaulId) {
        const url = `${this.baseUrl}/orders/shipments/changeLineHaul`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ shipmentId, fbmAccount, lineHaulId }),
        });
    }

    async changeOrderLineHaul(orderId, fbmAccount, lineHaulId) {
        const url = `${this.baseUrl}/orders/changeLineHaul`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ orderId, fbmAccount, lineHaulId }),
        });
    }
}

export { FBMOrdersV2Api };
